import { COUNTRIES, CURRENT_COUNTRY_ID } from '~constants/environment';
import { DELIVERY_COMPANIES_THAT_DONT_ACCEPT_TIPS } from '~constants/delivery';

export const disableTipsForGitfCardUsage = (total, useGiftCard) =>
  [COUNTRIES.es, COUNTRIES.pt].includes(CURRENT_COUNTRY_ID) && useGiftCard && total === 0;

export const disableForCouponUsage = shoppingCart =>
  shoppingCart?.discount === shoppingCart?.subtotal + shoppingCart?.delivery;

const deliveryCompanyAcceptTips = externalDeliveryCompany =>
  !DELIVERY_COMPANIES_THAT_DONT_ACCEPT_TIPS.includes(externalDeliveryCompany);

// eslint-disable-next-line id-length
export const externalDeliveryCompanyAcceptTips = (externalDeliveryActive, externalDeliveryCompany) =>
  !externalDeliveryActive || (externalDeliveryActive && deliveryCompanyAcceptTips(externalDeliveryCompany));
